import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 9.3V4h-3v2.6L12 3 2 12h3v8h5v-6h4v6h5v-8h3l-3-2.7zm-9 .7c0-1.1.9-2 2-2s2 .9 2 2h-4z"
}), 'HouseSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/HouseSharp.js
// module id = 4183
// module chunks = 2